<template>
  <div id="prod-editor">
    <mt-header fixed title="编辑产品信息">
      <router-link :to="backUrl" slot="left">
        <mt-button icon="back">返回</mt-button>
      </router-link>
    </mt-header>
    <mt-field label="产品名称" placeholder="请输入产品名称" class="required" v-model="prodInfo.name"></mt-field>
    <mt-field label="生产标准" placeholder="请输入生产标准" v-model="prodInfo.stdCode"></mt-field>
    <mt-field label="许可证号" placeholder="请输入许可证号" v-model="prodInfo.qsCode"></mt-field>
    <mt-field label="产品规格" placeholder="请输入产品规格" v-model="prodInfo.specification"></mt-field>
    <mt-field label="生产地址" placeholder="请输入生产地址" type="textarea" rows="2" v-model="prodInfo.address"></mt-field>
    <mt-field label="生产原料" placeholder="请输入生产原料" v-model="prodInfo.material"></mt-field>
    <mt-field label="贮存条件" placeholder="请输入贮存条件" v-model="prodInfo.storage"></mt-field>
    <!-- <mt-field label="每箱产品数" placeholder="请输入包装数量" type="number" v-model="prodInfo.pkgNum"></mt-field> -->
    <mt-field label="保质期" placeholder="请输入保质期" type="number" v-model="prodInfo.qualityPeriod">
      <span>月</span>
    </mt-field>
    <mt-field label="产品简介" placeholder="请输入产品简介" type="textarea" rows="5" v-model="prodInfo.introduction"></mt-field>
    <upload-field label="产品图片" :required="true" v-model="prodInfo.imageId"></upload-field>
    <div class="page-btn">
      <mt-button type="primary" size="large" @click.native="saveProd">保存</mt-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import "mint-ui/lib/style.css";
import { Toast, Cell, Button, Field, Header } from "mint-ui";
import UploadField from "./UploadField";
export default {
  components: {Toast,Header,Button,Cell,Field,UploadField},
  props: ["prodId"],
  data: function() {
    return {
      prodInfo: {
        id: null,
        name: null,
        introduction: null,
        qualityPeriod: null,
        stdCode: null,
        qsCode: null,
        specification: null,
        pkgNum: 1,
        address: null,
        material: null,
        storage: null,
        imageId: null
      }
    };
  },
  computed: {
    backUrl() {
      if (this.prodId) {
        return "/prod/view?id=" + this.prodId;
      } else {
        return "/index/prod";
      }
    }
  },
  methods: {
    checkData() {
      return (
        this.prodInfo &&
        this.prodInfo.name &&
        this.prodInfo.imageId
      );
    },
    saveProd() {
      if(!this.checkData()){
        Toast("请完善产品信息！");
        return;
      }
      this.$http
        .post(this.GLOBAL.serverUrl + "/ent/prod", this.prodInfo)
        .then(function(resp) {
          if (resp.body.code == 200) {
            this.$store.dispatch('loadProdData');
            this.$router.push("/index/prod");
          } else if (resp.body.code == 500) Toast("获取数据失败，请稍后再试！");
        });
    },
    uploadFinish(e) {
      if (e.target.status == 200) {
        var resptext = e.target.response;
        window.console.log(resptext);
        var resp = JSON.parse(resptext);
        if (resp.success) {
          this.prodInfo.imageId = resp.data[0].id;
        } else {
          Toast("图片上传失败，请稍后重试！");
        }
      }
    }
  },
  mounted: function() {
    if (this.prodId) {
      this.$http
        .get(this.GLOBAL.serverUrl + "/ent/prod/" + this.prodId)
        .then(function(resp) {
          if (resp.body.code == 200) {
            this.prodInfo = resp.body.data;
          }
          else if (resp.body.code == 500) Toast("获取数据失败，请稍后再试！");
        });
    }
  }
};
</script>
<style scoped>
#prod-editor {
  padding-top: 40px;
}
.page-btn {
  margin-top: 1rem;
  padding: 1rem;
}
.mint-cell.is-textarea .mint-cell-title {
  padding: 0.5rem !important;
}
</style>